import { render } from "./FooterTheme3.vue?vue&type=template&id=2a2aff41&scoped=true"
import script from "./FooterTheme3.vue?vue&type=script&lang=js"
export * from "./FooterTheme3.vue?vue&type=script&lang=js"

import "./FooterTheme3.vue?vue&type=style&index=0&id=2a2aff41&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2aff41"]])

export default __exports__